import { ReactNode } from "react";

const DuoColorBorder = ({
	id,
	color,
	secondColor,
	children,
	extraClasses,
	direction,
	onClick,
	borderRadius,
	containerClasses,
}: {
	id: string;
	color: string;
	secondColor: string;
	children: ReactNode;
	direction: string;
	borderRadius?: string;
	extraClasses?: string;
	containerClasses?: string;
	onClick?: any;
}) => {
	const dynamicStyles = `
    #${id} .duo-tone-box {
      background-color: transparent;
      border-radius: ${borderRadius ?? "20px"};
      position: relative;
    }
    #${id} .duo-tone-box::before {
      content: "";
      position: absolute;
      inset: 0;
      padding: 2px;
      border-radius: ${borderRadius ?? "20px"};
      background: linear-gradient(${direction}, ${color}, ${secondColor});
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: destination-out;
      mask-composite: exclude;
      pointer-events: none;
    }
  `;

	return (
		<div id={id} onClick={onClick} className={`${containerClasses}`}>
			<style>{dynamicStyles}</style>
			<div className={`duo-tone-box backdrop-blur-lg ${extraClasses}`}>
				{children}
			</div>
		</div>
	);
};

export default DuoColorBorder;
